/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import {useEffect, useState} from 'react'
import { useRouter } from 'next/router'

import Header from '../../components/header'
import Layout from '../../components/layout'
import style from '../../components/pricing.module.css'
import utils from '../../components/utils'
import consts from '../../components/consts'
import PricingPackage from '../../components/pricingPackage'
import LoaderOverlay from '../../components/loaderOverlay'
import Loader from '../../components/loader'
import restUtils from '../../components/restUtils'

import { useStateValue } from '../../state';



export default function Pricing() {
  const [isFirstMount, updateIsFirstMount] = useState(true);
  const [isUserLoggedIn, updateIsUserLoggedIn] = useState(null);
  const [userData, updateUserData] = useState(null);

  const router = useRouter();

  const [
    {loading},
    dispatch
  ] = useStateValue();

  useEffect(() => {
    async function getUser() {
      try {
        let userDTO = await restUtils.post('user');
        updateUserData(userDTO.data);
      } catch (error) {
        console.log('error while fetching user: ' + error);
        updateUserData("");
      }

     }

     getUser();
  }, [])

  useEffect(() => {
    if(userData && userData != "" && userData.userId) {
      updateIsUserLoggedIn(true)
    } else if (userData === "") {  
      updateIsUserLoggedIn(false)
    }
  }, [userData])

 /* useEffect(() => {
    if(router) {
      let packageId = router.query['packageId'];
      packageId && updatePackageId(packageId);
    }
  }, [router])*/

  const pricingPackages = [
    {
      id: 2,
      //showPopularIcon: true,
      themeColor: '#822EE4',
      free: false,
      header: 'Pro',
      description: 'Everything a business needs',
      price: consts.PACKAGE_PRICES.BUSINESS,
      period: 'month',
      CTA: {
        text: consts.PRICING_PACKAGE_CTA.BUY,
        onClick: onProPackageClick
      },
      features: [
        {
          name: 'Unlimited transfers',
          //highlight: true,
          //ctaLink: `https://filedriver.com/?userId=${demoUserId}&demoSite=true&animatedDemo=true`,
        },
        {
          name: 'Up to 50GB per transfer',
        },
        {
          name: '30 days file retention'
        },
        {
          name: 'File tracking & analytics',
          comingSoon: true,
        },
        {
          name: <span>Everything in <b>Plus</b></span>
        },
      /*  {
          name: ' Download notifications'
        },*/
      ]
    },
    {
      id: 3,
      themeColor: '#2580DE',
      header: 'Plus',
      price: consts.PACKAGE_PRICES.SMB,
      period: 'month',
      description: 'More transfers and a personal touch',
      CTA: {
        text: consts.PRICING_PACKAGE_CTA.BUY,
        //url: '/posts/signup/?type=personal&packageId=1&source=pricing'
        onClick: onPlusPackageClick
      },
      features: [
        {
          name: 'Up to 20 transfers per month',
          //highlight: true,
          //ctaLink: `https://filedriver.com/?userId=${demoUserId}&demoSite=true&animatedDemo=true`,
        },
        {
          name: 'Up to 20GB per transfer'
        },
        {
          name: 'Custom branding'
        },
        {
          name: <span>Everything in <b>Free</b></span>
        },
      /*  {
          name: ' Download notifications'
        },*/
      ]
    },
    {
      id: 1,
      themeColor: '#13BCB4',
      customText: 'Free',
      header: 'Starter',
      description: 'Start free and upgrade as you grow',
      CTA: {
        text: consts.PRICING_PACKAGE_CTA.FREE,
        onClick: onFreeCtaClick,
        //url: isUserLoggedIn ? '/posts/payment/?packageId=1&source=pricing' : '/posts/signup/?type=personal&packageId=1&source=pricing'
        
      },
      features: [
        {
          name: 'Up to 4 transfers per month'
        },
        {
          name: 'Up to 2GB per transfer'
        },
        {
          name: '7 days file retention'
        },
        {
          name: 'unlimited downloads per file'
        },
        {
          name: 'Gmail Integration'
        },
        {
          name: 'Secured by design'
        },
      ]
    },
    {
      id: 4,
      disabled: true,
      themeColor: '#822EE4',
      customText: "Let's Talk",
      header: 'Premium',
      description: 'Everything in business plus:',
      price: '20',
      period: 'month',
      CTA: {
        text: consts.PRICING_PACKAGE_CTA.CONTACT_US,
        url: '/posts/join-beta'
      },
      features: [
        {
          name: 'Video and photo galleries'
        },
        {
          name: 'Email customization '
        },
        {
          name: 'Custom domain'
        },
        {
          name: 'Advanced collaboration features'
        },
        {
          name: 'Transfer analytics'
        },
        {
          name: 'Advanced security options'
        },
      ]
    }
  ]

  useEffect(() => {
    /*let isPaidUser = utils.getLocalStorageItem(consts.SELECTED_PACKAGE.PAYMENT_SUCCEEDED);
    if(isPaidUser) {
      //window.location.assign('/posts/signup'); //redirect paid user to complete signup
    }*/
    if(isFirstMount) {
     updateIsFirstMount(false);
     utils.trackPageView('pricing');
     utils.setSessionStorageItem(consts.SESSION_STORAGE_KEYS.COMPLETE_PURCHASE, false); //reset the session value
    }
    }, [])

    function signupAndSetCompletePurchase() {
      utils.setSessionStorageItem(consts.SESSION_STORAGE_KEYS.COMPLETE_PURCHASE, true);
      router.push('/posts/signup/?source=pricing');
    }

    function onPlusPackageClick() {
      //router.push('/posts/payment/?packageId=3&source=pricing') 
      if(isUserLoggedIn) {
        router.push('/posts/payment/?packageId=3&source=pricing');
      } else {
        signupAndSetCompletePurchase();
      }
    }

    function onProPackageClick() {
      //router.push('/posts/payment/?packageId=2&source=pricing')
      if(isUserLoggedIn) {
        router.push('/posts/payment/?packageId=2&source=pricing');
      } else {
        signupAndSetCompletePurchase();
      }
    }

    async function onFreeCtaClick() {
      if(isUserLoggedIn && userData.isPaying) {
        dispatch({ type: 'LOADING-CHANGED', payload: true}); 
        utils.trackEvent(consts.TRACKING_CATEGORY.PRICING, 'cancel_subscription','signup_id',userData.userId);
        await restUtils.post('cancelSubscription', null, true);
        dispatch({ type: 'LOADING-CHANGED', payload: false}); 
        router.push('/');
      } else {
        signupAndSetCompletePurchase();
      }
    }

  function renderPricingPackages() {
    return pricingPackages.map((p) => {
      return !p.disabled && <PricingPackage show={true} key={p.header} header={p.header} description={p.description} price={p.price}
      period={p.period} features={p.features} themeColor={p.themeColor} cta={p.CTA} packageId={p.id}
      showPopularIcon={p.showPopularIcon} customText={p.customText} disabled={userData && userData.planInfo && userData.planInfo.packageId == p.id}
      isUserLoggedIn={isUserLoggedIn}/>
    })
  }

    return (
      <React.Fragment>
      {loading && <LoaderOverlay>
      <span className={style.loaderText}>{'Loading...'}</span>
      <span className={style.loaderTextSubHeadline}>This may take a few seconds, please don't close this page.</span>
      </LoaderOverlay>}
      {userData === null ? <Loader/> : 
            <div className={style.container}>
            <Layout>
            <Header hideSignupLink={true}/>
            </Layout>
            <span className={style.title}>{router && router.query['source'] === 'complete-purchase' ? 'Complete Purchase' : 'A plan for every stage'}</span>
            <span className={style.description}>{router && router.query['source'] === 'complete-purchase' ? '' : 'Value-based pricing, pick the plan according to your needs'}</span>
            <div className={style.pricingPackagesContainer}>
            {renderPricingPackages()}
            </div>
            </div>
      }
      </React.Fragment>
    );
  }